import { apiClientGeral } from '@/plugins/axios'

export default {
  getGruposRamais() {
    return apiClientGeral().get('/gruposatendimento')
  },
  getGrupoRamal(id) {
    return apiClientGeral().get(`/gruposatendimento/${id}`)
  },
  postGrupoRamal(grupo) {
    return apiClientGeral().post('/gruposatendimento', grupo)
  },
  putGrupoRamal(grupo) {
    return apiClientGeral().put(`/gruposatendimento/${grupo._id}`, grupo)
  },
  deleteGruposRamais(id) {
    return apiClientGeral().delete(`/gruposatendimento/${id}`)
  },
  getRamais() {
    return apiClientGeral().get('/ramais')
  },
}
